import React, { useState, useEffect } from 'react';
import API_URL from '../config';
import Header from './Header';

// Função utilitária para formatação segura
function safeToFixed(value, digits = 2) {
  const num = Number(value);
  return isNaN(num) ? '0.00' : num.toFixed(digits);
}

function PedidosPage({ usuario, empresa, pedidoId = null, onVoltar, onSair }) {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [pedidos, setPedidos] = useState([]);
  const [loadingPedidos, setLoadingPedidos] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(pedidoId);
  const [novo, setNovo] = useState(false);
  const [form, setForm] = useState({ mesa: '' });
  const [salvando, setSalvando] = useState(false);

  // Buscar todos os pedidos
  useEffect(() => {
    if (!pedidoSelecionado) {
      setLoadingPedidos(true);
      fetch(`${API_URL}/pedidos?empresa_id=${empresa.id}`)
        .then(res => res.json())
        .then(data => setPedidos(Array.isArray(data) ? data : []))
        .catch(() => setPedidos([]))
        .finally(() => setLoadingPedidos(false));
    }
  }, [empresa.id, pedidoSelecionado]);

  // Buscar detalhes do pedido selecionado
  useEffect(() => {
    if (pedidoSelecionado) {
      setLoading(true);
      setErro('');
      fetch(`${API_URL}/pedidos/${pedidoSelecionado}?empresa_id=${empresa.id}`)
        .then(res => {
          if (!res.ok) throw new Error('Erro ao buscar pedido');
          return res.json();
        })
        .then(pedido => setDados(pedido))
        .catch(e => setErro(e.message || 'Erro ao buscar pedido'))
        .finally(() => setLoading(false));
    }
  }, [pedidoSelecionado, empresa.id]);

  // Função para novo pedido
  const novoPedido = () => {
    setNovo(true);
    setForm({ mesa: '' });
  };

  // Função para salvar novo pedido
  const salvarNovoPedido = async () => {
    if (!form.mesa) return alert('Preencha o campo Mesa!');
    setSalvando(true);
    try {
      const res = await fetch(`${API_URL}/pedidos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ empresa_id: empresa.id, mesa: form.mesa })
      });
      if (!res.ok) throw new Error('Erro ao salvar pedido');
      setNovo(false);
      setForm({ mesa: '' });
      setPedidoSelecionado(null);
      // Atualizar listagem
      setLoadingPedidos(true);
      const pedidosAtualizados = await fetch(`${API_URL}/pedidos?empresa_id=${empresa.id}`).then(r => r.json());
      setPedidos(Array.isArray(pedidosAtualizados) ? pedidosAtualizados : []);
      setLoadingPedidos(false);
    } catch (e) {
      alert(e.message || 'Erro ao salvar pedido');
      setSalvando(false);
    }
  };

  // Função para editar pedido
  const editarPedido = id => setPedidoSelecionado(id);

  // Função para excluir pedido (mock)
  const excluirPedido = async id => {
    if (!window.confirm('Deseja realmente excluir este pedido?')) return;
    await fetch(`${API_URL}/pedidos/${id}`, { method: 'DELETE' });
    setPedidos(pedidos.filter(p => p.id !== id));
  };

  if (!pedidoSelecionado) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
        <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
        <div className="max-w-3xl mx-auto mt-10 bg-white rounded-2xl shadow-2xl p-8 border border-blue-100">
          <h2 className="text-2xl font-bold text-blue-700 mb-6">Pedidos</h2>
          {novo ? (
            <div className="mb-6 p-4 bg-blue-50 rounded shadow flex flex-col gap-2 max-w-xs mx-auto">
              <h3 className="font-bold text-blue-700 mb-2">Novo Pedido</h3>
              <input
                type="text"
                placeholder="Mesa"
                value={form.mesa}
                onChange={e => setForm(f => ({ ...f, mesa: e.target.value }))}
                className="border rounded px-3 py-2 mb-2"
                required
              />
              <div className="flex gap-2">
                <button onClick={salvarNovoPedido} disabled={salvando} className="flex-1 py-2 rounded bg-blue-600 text-white font-bold hover:bg-blue-700 transition">Salvar</button>
                <button onClick={() => setNovo(false)} disabled={salvando} className="flex-1 py-2 rounded bg-gray-200 text-gray-700 font-bold hover:bg-gray-300 transition">Cancelar</button>
              </div>
            </div>
          ) : (
            <button onClick={novoPedido} className="mb-4 px-4 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700">Novo Pedido</button>
          )}
          {!novo && (loadingPedidos ? (
            <div>Carregando pedidos...</div>
          ) : (
            <table className="min-w-full text-sm text-center border">
              <thead>
                <tr className="bg-blue-50">
                  <th>ID</th>
                  <th>Mesa</th>
                  <th>Emissão</th>
                  <th>Total</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {pedidos.map(p => (
                  <tr key={p.id} className="border-b">
                    <td>{p.id}</td>
                    <td>{p.mesa}</td>
                    <td>{p.emissao ? new Date(p.emissao).toLocaleString() : '-'}</td>
                    <td>R$ {Number(p.total || 0).toFixed(2)}</td>
                    <td>
                      <button onClick={() => editarPedido(p.id)} className="text-blue-600 hover:underline mr-2">Editar</button>
                      <button onClick={() => excluirPedido(p.id)} className="text-red-600 hover:underline">Excluir</button>
                    </td>
                  </tr>
                ))}
                {pedidos.length === 0 && (
                  <tr><td colSpan={5} className="py-8 text-center text-gray-500">Nenhum pedido encontrado.</td></tr>
                )}
              </tbody>
            </table>
          ))}
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-md border border-blue-100 flex flex-col items-center max-h-[80vh] overflow-y-auto">
        <div className="text-blue-700 font-bold py-12">Carregando pedido...</div>
      </div>
    );
  }
  if (erro) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300 flex items-center justify-center">
        <div className="bg-white p-8 rounded-2xl shadow text-red-600 font-bold">{erro}</div>
      </div>
    );
  }
  if (!dados) return null;

  return (
    <div>
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-md border border-blue-100 flex flex-col items-center max-h-[80vh] overflow-y-auto">
          <h2 className="text-xl font-bold text-blue-700 mb-2">{dados.mesa || 'Pedido'}</h2>
          {/* Conteúdo das Abas */}
          {/* Listagem igual à aba produtos, mas sem botões de remover */}
          {dados.itens.map(item => (
            <div key={item.id} className="flex items-start justify-between border-b py-2 gap-2">
              <div className="flex-1">
                <div className="font-medium text-gray-800">{item.produto_nome || item.produto}</div>
                <div className="text-xs text-gray-500">{item.quantidade} UN x R$ {safeToFixed(item.unitario)}</div>
                {item.adicionais && item.adicionais.length > 0 && (
                  <div className="text-xs text-gray-600 mt-1">
                    {item.adicionais.map((ad, idx) => (
                      <div key={idx} className="text-xs text-gray-500 flex items-center">
                        <span className="mr-1">* {ad.adicional_nome}</span>
                        {ad.item_nome && <span className="ml-1">- {ad.item_nome}</span>}
                      </div>
                    ))}
                  </div>
                )}
                {item.observacao && (
                  <div className="text-xs text-gray-700 mt-1 font-bold">Obs. {item.observacao}</div>
                )}
              </div>
              <div className="flex flex-col items-end">
                <div className="text-base font-semibold text-gray-800">R$ {safeToFixed(item.total)}</div>
              </div>
            </div>
          ))}
          {/* Resumo financeiro */}
          <div className="mt-4 text-sm">
            <div className="flex justify-between"><span>Subtotal</span><span>R$ {safeToFixed(dados.subtotal)}</span></div>
            <div className="flex justify-between"><span>Desconto na venda</span><span>- R$ {safeToFixed(dados.desconto)}</span></div>
            <div className="flex justify-between"><span>Taxa Garçom</span><span>+ R$ {safeToFixed(dados.taxa_garcom)}</span></div>
            <div className="flex justify-between font-bold text-lg mt-2"><span>Total</span><span>R$ {safeToFixed(dados.total)}</span></div>
          </div>
          {/* Botões de ação */}
          <div className="flex gap-4 mt-8 w-full">
            <button className="flex-1 py-2 rounded bg-blue-600 text-white font-bold hover:bg-blue-700 transition">Pagamento</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PedidosPage; 